import React from 'react';
import { getCharacterImageLayers } from '../../utils/characterPresets';
import './IllustratedCharacter.css';

interface Props {
  src?: string;
  alt: string;
  style?: React.CSSProperties;
  className?: string;
  idle?: boolean;
}

/** Same full canvas for the fixed character and fitted top; legacy art stays flattened. */
export default function IllustratedCharacter({ src, alt, style, className = '', idle = false }: Props) {
  const layers = getCharacterImageLayers(src);
  const { objectFit = 'contain', objectPosition = 'center', ...boxStyle } = style || {};
  return (
    <span role="img" aria-label={alt} className={`maru-illustrated-character ${className}`}
      style={{ display: 'inline-block', position: 'relative', flexShrink: 0, ...boxStyle }}>
      <span className={idle ? 'maru-character-art maru-character-idle' : 'maru-character-art'}>
        {layers.map((url, index) => <img key={index} src={url} alt="" draggable={false}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit, objectPosition, pointerEvents: 'none' }} />)}
      </span>
    </span>
  );
}
